import React from 'react';
import { StyleProp, ViewStyle, View } from 'react-native';
import Svg, { Path, Defs, Stop, LinearGradient } from 'react-native-svg';

const HexagonFile = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 58}
          height={props.height ?? 52}
          viewBox="0 0 58 52"
          fill="none"
          {...props}
        >
          <Path
            d="M45.3347 3.23304C44.4521 1.68236 42.2592 0.425781 40.4674 0.425781H17.5216C15.7298 0.425781 13.5636 1.68236 12.6543 3.23304L1.18143 23.0977C0.298899 24.6484 0.298899 27.1615 1.18143 28.7122L12.6543 48.5769C13.5368 50.1276 15.7298 51.3842 17.5216 51.3842H40.4674C42.2592 51.3842 44.4254 50.1276 45.3347 48.5769L56.8076 28.7122C57.6901 27.1615 57.6901 24.6484 56.8076 23.0977L45.3347 3.23304Z"
            fill="url(#paint0_linear_1_39126)"
          />
          <Path
            d="M44.0932 6.0454C43.3213 4.68468 41.4033 3.58203 39.8361 3.58203H19.767C18.1999 3.58203 16.3052 4.68468 15.5099 6.0454L5.4754 23.4766C4.70351 24.8373 4.70351 27.0426 5.4754 28.4034L15.5099 45.8346C16.2818 47.1953 18.1999 48.298 19.767 48.298H39.8361C41.4033 48.298 43.2979 47.1953 44.0932 45.8346L54.1277 28.4034C54.8996 27.0426 54.8996 24.8373 54.1277 23.4766L44.0932 6.0454Z"
            fill="white"
          />
          <Path
            d="M42.3299 8.49944C41.6532 7.30652 39.9717 6.33984 38.5978 6.33984H21.0036C19.6296 6.33984 17.9687 7.30652 17.2714 8.49944L8.47432 23.7811C7.79762 24.974 7.79762 26.9074 8.47432 28.1003L17.2714 43.382C17.9481 44.5749 19.6296 45.5416 21.0036 45.5416H38.5978C39.9717 45.5416 41.6327 44.5749 42.3299 43.382L51.127 28.1003C51.8037 26.9074 51.8037 24.974 51.127 23.7811L42.3299 8.49944Z"
            fill="#FCEABB"
          />
          <Path
            d="M32.9961 15.9062H24.9961C21.4961 15.9062 19.9961 17.9062 19.9961 20.9062V30.9062C19.9961 33.9062 21.4961 35.9062 24.9961 35.9062H32.9961C36.4961 35.9062 37.9961 33.9062 37.9961 30.9062V20.9062C37.9961 17.9062 36.4961 15.9062 32.9961 15.9062ZM24.9961 26.1562H28.9961C29.4061 26.1562 29.7461 26.4963 29.7461 26.9062C29.7461 27.3162 29.4061 27.6562 28.9961 27.6562H24.9961C24.5861 27.6562 24.2461 27.3162 24.2461 26.9062C24.2461 26.4963 24.5861 26.1562 24.9961 26.1562ZM32.9961 31.6562H24.9961C24.5861 31.6562 24.2461 31.3162 24.2461 30.9062C24.2461 30.4963 24.5861 30.1562 24.9961 30.1562H32.9961C33.4061 30.1562 33.7461 30.4963 33.7461 30.9062C33.7461 31.3162 33.4061 31.6562 32.9961 31.6562ZM35.4961 23.1562H33.4961C31.9761 23.1562 30.7461 21.9262 30.7461 20.4062V18.4062C30.7461 17.9962 31.0861 17.6562 31.4961 17.6562C31.9061 17.6562 32.2461 17.9962 32.2461 18.4062V20.4062C32.2461 21.0963 32.8061 21.6562 33.4961 21.6562H35.4961C35.9061 21.6562 36.2461 21.9963 36.2461 22.4062C36.2461 22.8162 35.9061 23.1562 35.4961 23.1562Z"
            fill="#E89823"
          />
          <Defs>
            <LinearGradient
              id="paint0_linear_1_39126"
              x1="28.9945"
              y1="0.425781"
              x2="28.9945"
              y2="51.3842"
              gradientUnits="userSpaceOnUse"
            >
              <Stop stopColor="#FFCF53" />
              <Stop offset="1" stop-color="#FF9900" />
            </LinearGradient>
          </Defs>
        </Svg>
      </View>
    );
  },
);

export { HexagonFile };
